export namespace FieldNames {
  export enum FAQ {
    AnswerTitle = 'AnswerTitle',
    CategoryId = 'CategoryId',
    QuestionTitle = 'QuestionTitle',
    CategoryName = '$$CategoryName$$',
    CreatedDate = '$$CreatedDate$$',
  }

  export enum Filter {
    AccessRight = 'Access Right',
    ShareType = '$$ShareType$$',
    OwnerName = '$$OwnerName$$',
    OwnerFullName = '$$OwnerFullName$$',
    StaticQuery = 'StaticQuery',
  }

  export enum QA {
    FamilyId = 'FamilyId',
    Title = 'Title',
    CreatedDate = 'CreatedDate',
    FirstName = '$$FirstName$$',
    LastName = '$$LastName$$',
    SubjectMatter = '$$SubjectMatter$$',
    SubmittedBy = '$$SubmittedBy$$',
    RespondedBy = '$$RespondedBy$$',
    Email = '$$Email$$',
    Organization = '$$Organization$$',
    FileName = '$$FileName$$',
    DocumentUrl = '$$DocumentUrl$$',
    HasChildren = '$$HasChildren$$',
    RelatedDocument = '$$RelatedDocument$$',
    PostedDate = '$$PostedDate$$',
    IssueLevel = '$$IssueLevel$$',
    AccessRight = 'Access Right',
    QuestionTargetId = 'QuestionTargetId',
  }

  export enum ContactType {
    ContactTypeCategoryId = 'ContactTypeCategoryId', // system
    Title = 'Title',
  }

  export enum Document {
    //region Non-existing fields for UI logic only
    UIFieldPrefix = '$$UI$$',
    UIIndexPosition = '$$UI$$IndexPosition$$',
    UIAttachment = '$$UI$$Attachment$$',
    UIDtsClause = '$$UI$$DtsClause$$',
    UISearchRoomIds = '$$UI$$SearchRoomIds$$',
    UISearchDate = '$$UI$$SearchDate$$',
    UISearchMode = '$$UI$$SearchMode$$',
    UISearchTopicTypes = '$TopicTypes$',
    UISearchEntity = '$$UI$$SearchEntity$$', //todo: takeout to Search
    UICustomEffectiveDate = '$$UI$$CustomEffectiveDate$$',
    UICustomNextReviewDate = '$$UI$$CustomNextReviewDate$$',
    UICustomPeriodicReviewNotRequired = '$$UI$$CustomPeriodicReviewNotRequired$$',
    UICustomEffectiveVersion = '$$UI$$CustomEffectiveVersion$$',

    //endregion

    Tags = '$Tags$',
    PlaceholderId = '$PlaceholderId$',
    EventId = '$EventId$',
    EventTypeId = '$EventTypeId$',
    MilestoneId = '$MilestoneId$',
    MilestoneDate = '$MilestoneDate$',
    //MilestoneName = '$$MilestoneName$$',
    IsDocumentPopular = '$IsDocumentPopular$',
    Title = 'Title', // system
    DocumentDate = 'Document Date', // system
    Comments = 'Comments', // system
    CodingTypeId = 'CodingTypeId', // system
    CodingTypeName = '$$CodingTypeName$$',
    InvestigativeSiteId = 'InvestigativeSiteId', // system
    DocumentTypeId = 'DocumentTypeId', // system
    DocumentTypeName = '$$DocumentTypeName$$', // virtual
    DocumentName = 'DocumentName', // system
    ContactId = 'ContactId', // system
    ExpirationDate = 'Expiration Date', // system
    FixDocumentExpiration = '$$FixDocumentExpiration$$',
    ExportedDate = 'ExportedDate', // system
    ExportedBy = 'ExportedBy',
    ExportedByName = '$$ExportedBy$$',
    ExcludePageCount = 'ExcludePageCount', // system
    FileName = '$$FileName$$', // virtual
    OriginalFileName = '$$OriginalFileName$$',
    DocumentFileName = '$$DocumentFileName$$',
    DocumentStatusId = 'DocumentStatusId', // system
    DocumentStatusName = '$$DocumentStatusName$$',
    CompletenessStatus = '$$CompletenessStatus$$',
    CompletenessStatusId = '$$CompletenessStatusId$$',
    VisitStatus = '$$VisitStatus$$', // virtual
    VisitStatusId = '$$VisitStatusId$$', // virtual
    VisitDate = '$$VisitDate$$', // virtual
    VisitDocumentTypeId = '$$DocumentTypeId$$', // virtual
    AutoNameDisablingReason = 'AutoNameDisablingReason', // system
    FileToken = 'FileToken', // system
    DocumentId = '$$DocumentId$$',
    DocumentIndexList = '$$DocumentIndexList$$', // virtual
    DocumentFileSize = '$$DocumentFileSize$$',
    DocumentFullPath = '$$FullPath$$', // virtual
    IndexPath = '$$Index$$', // virtual
    SiteName = '$$SiteName$$',
    InvestigativeSiteName = '$$InvestigativeSiteName$$', // virtual
    ContactName = '$$ContactName$$', // virtual
    ContactType = '$$ContactType$$', // virtual
    ProcessingStatus = '$$Processing Status$$', // virtual
    TiAutomateStatusId = '$$TIAutomateStatusId$$',
    SubmissionDate = '$$Submission Date$$', // virtual
    CompletedDate = '$$Completed Date$$', // virtual
    AddedBy = '$$AddedBy$$', // virtual
    LastUpdatedBy = '$$LastUpdatedBy$$', // virtual
    LastUpdatedDate = '$$LastUpdatedDate$$', // virtual
    CreatedDate = '$$CreatedDate$$',
    ClaimDate = '$$ClaimDate$$', // virtual
    Workflows = '$$Workflows$$', // virtual
    Workflow = '$$Workflow$$', // virtual
    WorkflowStage = '$$WorkflowStage$$', // virtual
    MostRecentWorkflow = '$$CurrentWorkflow$$', // virtual
    MostRecentWorkflowStage = '$$CurrentWorkflowStage$$', // virtual
    WorkflowStatusTypeId = '$$WorkflowStatusTypeId$$',
    DocumentLifeCycleStatusName = '$$DocumentLifeCycleStatusName$$',
    VirtualIndexPosition = 'VirtualIndexPosition',
    VirtualVirtualIndexPosition = '$$VirtualIndexPosition$$',
    ReviewSubmissionDate = '$$ReviewSubmissionDate$$',
    ReviewStage = '$$$ReviewStage$$$',
    WorkflowStageStatus = '$$WorkflowStageStatus$$', // virtual
    FormIds = '$$FormIds$$', // virtual
    PublishedBy = '$$PublishedBy$$',
    PublishedById = 'PublishedBy',
    CurrentWorkflowReviewer = '$$CurrentWorkflowReviewer$$',
    DocumentNameManuallyUpdate = 'DocumentNameManuallyUpdate',
    DeletedBy = '$$DeletedBy$$',
    DeletedById = 'DeletedBy',
    DeleteComments = '$$DeleteComments$$',
    IRBId = 'IRBId',
    IRBId2 = 'IRBId2',
    IRBName = '$$IRBName$$',
    ReceivedDate = '$$ReceivedDate$$',
    AccessRight = 'Access Right',
    SubmittedOn = '$$SubmittedOn$$',
    Country = '$Country$',
    CountryName = '$$CountryName$$',
    EssentialDocumentStatusDate = '$$EssentialDocumentStatusDate$$',
    RegulatoryApprovalStatusId = '$$RegulatoryApprovalStatusId$$',
    EssentialDocumentStatusId = '$$EssentialDocumentStatusId$$',
    RegulatoryApprovalStatus = '$$RegulatoryApprovalStatus$$',
    EssentialDocumentStatus = '$$EssentialDocumentStatus$$',
    SSURejectionReason = '$$SSURejectionReason$$',
    SponsorComments = '$$SponsorComments$$',
    QCReviewStatusId = '$$QCReviewStatusId$$',
    QCReviewStatus = '$$QCReviewStatus$$',
    IsEssentialDocument = '$$IsEssentialDocument$$',
    IsStartupDocument = '$$IsStartupDocument$$',
    RequiredFieldsMissing = '$$RequiredFieldsMissing$$',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    DeletedByReal = 'DeletedBy',
    DeletedDate = 'DeletedDate',
    RecoveredBy = 'RecoveredBy',
    RecoveredDate = 'RecoveredDate',
    SenderAddress = 'Sender Address',
    SenderName = 'Sender Name',
    NativeFile = 'N_FILE', // system
    ConvertedFile = 'P_FILE', // system
    SignedFile = 'E_FILE', // system
    ProtectedFile = 'X_FILE', // system
    OcrStatusId = '$$OcrStatusId$$',
    Version = '$$Version$$',
    QueryType = '$$QueryType$$',
    QueryTypeId = '$$QueryTypeId$$',
    QueryId = '$$QueryId$$',
    QueryDate = '$$QueryDate$$',
    QueryResponse = '$$QueryResponse$$',
    QueryCreatedBy = '$$QueryCreatedBy$$',
    IsDocumentInTheQuery = '$$IsDocumentInTheQuery$$',
    DocumentUrl = '$DocumentUrl$',
    LinkId = '$LinkId$',
    NotApplicable = '$$NotApplicable$$',
    NotApplicableReason = '$$NotApplicableReason$$',
    DocumentSource = '$$DocumentSource$$',
    ExcludeFromExpired = '$ExcludeFromExpired$',
    IsExpiring = '$$IsExpiring$$',
    IsExpired = '$$IsExpired$$',
    IsRejected = '$$IsRejected$$',
    InvestigativeSiteStatusId = '$$InvestigativeSiteStatusId$$',
    IsDocumentCloned = '$IsDocumentCloned$',
    ReadyForEtmf = '$ReadyForEtmf$',
    AllowUnlockForReview = '$$AllowUnlockForReview$$',
    AllowTMFPublishing = '$$AllowTMFPublishing$$',
    AllowPdfConversion = '$$AllowPdfConversion$$',
    AllowMsgConversion = '$$AllowMsgConversion$$',
    AllowRedactions = '$$AllowRedactions$$',
    AllowPageManipulations = '$$AllowPageManipulations$$',
    AllowESignature = '$$AllowESignature$$',
    AllowDocumentStatusChange = '$$AllowDocumentStatusChange$$',
    CopiedToLinkedRoomsDate = '$CopiedToLinkedRoomsDate$',
    CopiedToLinkedRoomsBy = '$$CopiedToLinkedRoomsBy$$',
    CopiedToLinkedRoomsById = '$CopiedToLinkedRoomsBy$',
    eSignatureStatus = '$$eSignatureStatus$$',
    ParentId = '$$ParentId$$',
    DocumentFolderId = '$$DocumentFolderId$$',
    ClonedFrom = '$ClonedFrom$',
    ClonedTo = '$ClonedTo$',
    ClonedToSiteId = '$$ClonedToSiteId$$',
    DocumentDistributed = '$$DocumentDistributed$$',
    IsFavorite = '$$IsFavorite$$',
    UserComments = '$$UserComments$$',
    PublishToETMFStatusId = '$$PublishToETMFStatusId$$',
    EmailSender = '$EmailSender$',
    EmailRecepients = '$EmailRecepients$',
    EmailRecepientsCC = '$EmailRecepientsCC$',
    CraDocumentStatus = '$CraDocumentStatus$',
    CraReconcileDate = '$CraReconcileDate$',
    HasOpenedESignRequest = '$$HasOpenedESignRequest$$',
    eSignatureCreatedById = '$$eSignatureCreatedById$$',
    SourceTopicId = 'SourceTopicId',
    SourceTopicFileId = 'SourceTopicFileId',
    UploadSource = '$UploadSource$',
    Language = '$Language$',
    LanguageName = '$$LanguageName$$',
    RequiredByName = '$$RequiredByName$$',
    AllowEditDocumentOnline = '$$AllowDocumentEditOnline$$',
    AllowEditDocumentOffline = '$$AllowDocumentEditOffline$$',
    ParentLockTypeId = '$$ParentLockTypeId$$',
    LockTypeId = '$$LockTypeId$$',
    LockOwnerId = '$$LockOwnerId$$',
    LockOwnerName = '$$LockOwnerName$$',
    TmfApplicable = 'TMFApplicable',
    DocumentOwnerId = '$DocumentOwnerId$',
    DocumentOwnerName = '$$DocumentOwnerName$$',
    OtherDocumentOwnersExist = '$$OtherDocumentOwnersExist$$',
    IsDocumentInReview = '$$IsDocumentInReview$$',
    DocumentReviewType = '$$DocumentReviewType$$',
    EnableDocumentCheckin = '$$EnableDocumentCheckin$$',
    EnableDocumentCheckout = '$$EnableDocumentCheckout$$',
    EnableDocumentEditOnline = '$$EnableDocumentEditOnline$$',
    DocumentEditOnlineReviewTopicId = '$$EditOnlineReviewDocumentTopicId$$',
    EditOnlineCollaborationReviewId = '$$EditOnlineCollaborationReviewId$$',
    EnableIncludeInChangeControlWorkflow = '$$EnableIncludeInChangeControlWorkflow$$',
    RequireIncludeInChangeControlWorkflow = '$$RequireIncludeInChangeControlWorkflow$$',
    IsDocumentRequireChangeControlWorkflow = '$$IsDocumentRequireChangeControlWorkflow$$',
    IsDocumentWaitingToBeEffective = '$$IsDocumentWaitingToBeEffective$$',
    IsDocumentInChangeControlWorkflow = '$$IsDocumentInChangeControlWorkflow$$',
    AvailableForMonitoringVisitWorkflow = '$$AvailableForMonitoringVisitWorkflow$$',
    CurrentWorkflowTypeId = '$$CurrentWorkflowTypeId$$',
    EffectiveDate = '$EffectiveDate$',
    NextReviewDate = '$NextReviewDate$',
    EffectivePeriod = '$EffectivePeriod$',
    NextReviewPeriod = '$NextReviewPeriod$',
    AutoPredictedDocType = '$AutoPredictedDocType$',
    TrueCopyCert = '$TrueCopyCert$',
    OriginalDocumentHash = '$$OriginalDocumentHash$$',
    DocumentHash = '$$DocumentHash$$',
    NFileOriginalHash = '$$NFile_OriginalHash$$', // not used anymore
    RequirementId = '$$RequirementId$$',
    InheritFolderSecurity = '$$InheritFolderSecurity$$',

    PageCount = '$$PageCount$$',
    DocumentNameLastUpdatedBy = '$$DocumentNameLastUpdatedBy$$',

    ObsoleteBy = '$$ObsoleteBy$$',
    ObsoleteDate = '$$ObsoleteDate$$',
    ObsoleteComments = '$$ObsoleteComments$$',

    AllowRetryDocumentTypeRecognition = '$$AllowRetryDocumentTypeRecognition$$',
    IsDocumentInAudit = '$$IsDocumentInAudit$$',
    AuditProfileId = '$$AuditProfileId$$',

    ReviewDocumentIndexFolderId = '$$ReviewDocumentIndexFolderId$$',
    EffectiveImmediately = '$EffectiveImmediately$',
    PeriodicReviewNotRequired = '$PeriodicReviewNotRequired$',
    CollaborationReviewData = '$$CollaborationReviewData$$',
    EffectiveStatusId = '$EffectiveStatusId$',
    IsCCWFPassed = '$IsCCWFPassed$',
    DefaultWorkflowId = '$$DefaultWorkflowId$$',

    DuplicateStatusId = '$DuplicateStatus$', // system
    PotentialDuplicateStatus = '$$PotentialDuplicateStatus$$', // virtual
    ResponsibleDepartmentId = '$$ResponsibleDepartmentId$$', // virtual
    ResponsibleDepartmentName = '$$ResponsibleDepartmentName$$', // virtual
    StartingVersion = '$StartingVersion$',
    EnableSetStartingVersion = '$$EnableSetStartingVersion$$',
    WorkingVersion = '$$WorkingVersion$$',
    WorkflowStageReviewStatus = '$$CurrentWorkflowStageReviewStatus$$',
    ResponsiblePartyType = '$$ResponsiblePartyType$$', // virtual
    ResponsiblePartyTypeId = '$ResponsiblePartyTypeId$',
    LockEntityId = '$$LockEntityId$$',
    LockEntityParentId = '$$LockEntityParentId$$',
    MdeCoded = '$$KofaxCoded$$',
    IsUserDocumentOwner = '$$IsUserDocumentOwner$$',

    PublishedDate = '$$PublishedDate$$',
    PublishedDate2 = 'PublishedDate',

    EnableDocumentDelete = '$$EnableDocumentDelete$$',
    EnableDocumentObsolete = '$$EnableDocumentObsolete$$',

    CheckedOutBy = '$$CheckedOutBy$$', // virtual?
    DocumentOwnerIdName = '$$DocumentOwnerId$$', // virtual?

    Zone = '$$Zone$$',
    Section = '$$Section$$',
    Artifact = '$$Artifact$$',
    SubArtifact = '$$SubArtifact$$',
    IndexNumber = '$$IndexNumber$$',
    Description = '$$Description$$',
    Instructions = '$$Instructions$$',

    SharedById = '$SharedBy$',
    SharedBy = '$$SharedBy$$',
    SharingDate = '$SharingDate$',

    IsSiteContact = '$$IsSiteContact$$',

    TemplateDataFields = '$TemplateDataFields$',

    AlfrescoDocumentId = '$$AlfrescoDocumentId$$', //?

    TemplateFolderId = '$$TemplateFolderId$$',

    EventCompletedDate = '$$CompletedDate$$',

    EventTypeName = '$$EventTypeName$$',

    EventName = '$$EventName$$',

    VisitId = '$VisitId$',
    VisitArtifact = '$$VisitArtifact$$',
    UseSimplifiedSignature = '$$UseSimplifiedSignature$$',
    DoNotDistribute = '$$DoNotDistribute$$',
    UserDoNotDistribute = '$DoNotDistribute$',

    EffectiveVersion = '$EffectiveVersion$',
    NeedRedaction = '$NeedRedaction$',

    NeedRedactionRequestor = '$$NeedRedactionRequestor$$',
    RedactionRequestDate = '$$RedactionRequestDate$$',
    RedactionStatusId = '$RedactionStatusId$',
    RedactionCompletedBy = '$$RedactionCompletedBy$$',
    RedactionCompletedDate = '$$RedactionCompletedDate$$',
    NotRequiredForCompleteness = '$NotRequiredForCompleteness$',
    NotRequiredForCompletenessReason = '$NotRequiredForCompletenessReason$',
    ChangeControlWorkflowStatusId = '$$ChangeControlWorkflowStatusId$$',

    FileProcessingCode = '$$FileProcessingCode$$',
    FileProcessingMessage = '$$FileProcessingMessage$$',

    RejectionReason = '$RejectionReason$',
    DocumentRejected = '$$DocumentRejected$$',
    RejectionReasonVirtual = '$$RejectionReason$$',
    RejectionComments = '$RejectionComments$',
    TrainingNeeded = '$TrainingNeeded$',

    InvestigativeSiteCountryCode = '$$InvestigativeSiteCountryCode$$',
    HasConcurrentPlaceholder = '$$HasConcurrentPlaceholder$$',
    EventDueDate = '$$EventDueDate$$',
    IsOverdue = '$$IsOverdue$$',
    IsCollectedDocument = '$$IsCollectedDocument$$',

    ConfidenceScore = '$ConfidenceScore$',
    ConfidenceScoreFieldsOverwritten = '$$ConfidenceScoreFieldsOverwritten$$',
    ConfidenceScoreNumberOfFieldsOverwritten = '$$ConfidenceScoreNumberOfFieldsOverwritten$$',

    FileHash = '$$FileHash$$',
    ParentTopicTypeId = '$$ParentTopicTypeId$$',
    EssentialFor = '$$EssentialFor$$',
    EssentialForId = '$$EssentialForId$$',
    EssentialForId2 = '$$EssentialForId2$$',
    AmendmentProfileId = '$$AmendmentProfileId$$',

    WorkingDocumentsIndexId = '$$WorkingDocumentsIndexId$$',
    WorkingDocumentsIndexPath = '$$WorkingDocumentsIndexPath$$',

    CTMSVisitUrl = '$CTMSVisitUrl$',
    HasRejectedVersions = '$$HasRejectedVersions$$',
    PeriodicReviewOverdue = '$$PeriodicReviewOverdue$$',
    MatchingDocuments = '$$MatchingDocuments$$',

    StorageTypeId = '$$StorageTypeId$$',

    IsSigned = '$IsSigned$',
    IsPasswordProtected = '$IsPasswordProtected$',
    IsPortfolio = '$IsPortfolio$',
    RelatedEntityTopicTypeId = '$$RelatedEntityTopicTypeId$$',

    AcknowledgmentRecipientStatusId = '$$AcknowledgmentRecipientStatusId$$',
    AcknowledgmentRecipientStatusName = '$$AcknowledgmentRecipientStatusName$$',
    AcknowledgmentAssigneeStatusId = '$$AcknowledgmentAssigneeStatusId$$',
    AcknowledgmentAssigneeStatusName = '$$AcknowledgmentAssigneeStatusName$$',
    AcknowledgmentDocumentStatusId = '$$AcknowledgmentDocumentStatusId$$',
    AcknowledgmentDocumentStatusName = '$$AcknowledgmentDocumentStatusName$$',
    AcknowledgmentDocumentCompletion = '$$AcknowledgmentDocumentCompletion$$',
    AcknowledgmentDocumentDueDate = '$$AcknowledgmentDocumentDueDate$$',
    AcknowledgmentDocumentInvestigativeSitesCount = '$$AcknowledgmentDocumentInvestigativeSitesCount$$',
    AcknowledgmentDocumentInvestigativeSites = '$$AcknowledgmentDocumentInvestigativeSites$$',
    EnableForAcknowledgement = '$$EnableForAcknowledgement$$',

    CollaborationReviewName = '$$CollaborationReviewName$$',
    CollaborationReviewStatusName = '$$CollaborationReviewStatusName$$',
    CollaborationReviewUserStatusName = '$$CollaborationReviewUserStatusName$$',
    CollaborationReviewProgress = '$$CollaborationReviewProgress$$',

    SponsorStatusId = '$$SponsorStatusId$$',
    SponsorStatus = '$$SponsorStatus$$',
    SponsorStatusDate = '$SponsorStatusDate$',
    SponsorApprover = '$$SponsorApprover$$',
    SponsorStatusDate$ = '$$SponsorStatusDate$$', // use only for grid

    OrganizationId = '$OrganizationId$',
    Organization = '$$Organization$$',

    DocumentIssues = '$$DocumentIssues$$',
    HasFillableForm = '$HasFillableForm$',

    UniversalId = '$$UniversalId$$',

    AllowTIAutomateRecode = '$$AllowTIAutomateRecode$$',
    AllowTIAutomateResubmit = '$$AllowTIAutomateResubmit$$',

    RiskLevel = '$$RiskLevel$$',
    RiskScore = '$$RiskScore$$',
    VirtualTopicId = '$$VirtualTopicId$$',
  }

  export enum SSUMetaDataFields {
    EssentialDocumentStatusId = 'EssentialDocumentStatusId',
    EssentialDocumentStatus = '$$EssentialDocumentStatus$$',
    EssentialDocumentStatusDate = '$$EssentialDocumentStatusDate$$',
    RegulatoryApprovalStatusId = 'RegulatoryApprovalStatusId',
    RegulatoryApprovalStatus = '$$RegulatoryApprovalStatus$$',
    SponsorStatusDate = '$$SponsorStatusDate$$',
    SponsorStatus = '$$SponsorStatus$$',
    SponsorStatusId = '$SponsorStatusId$',
    RequiredBy = 'RequiredBy',
    RequiredById = 'RequiredById',
    RequiredById2 = 'RequiredById2',
    ReceivedDate = 'ReceivedDate',
    ApprovedDate = 'ApprovedDate',
    EssentialRejectionDate = 'EssentialRejectionDate', // ?
    NotApplicable = '$NotApplicable$',
    NotApplicableReason = '$NotApplicableReason$',
    RequiredByName = '$$RequiredByName$$',
    RegulatoryApprovalDate = '$$RegulatoryApprovalDate$$',
    EssentialDocumentApprover = '$$EssentialDocumentApprover$$',
    RegulatoryApprover = '$$RegulatoryApprover$$',
    EssentialDocumentRejectReason = 'EssentialDocumentRejectReason', // ?
  }

  export enum Sponsor {
    UseESignature = '$UseESignature$',
    DocuSignUserId = '$DocuSignUserId$',
    DocuSignIsCfrAccount = '$DocuSignIsCfrAccount$',
    SponsorGroupId = 'SponsorGroupId',
    DocuSignAccountId = '$DocuSignAccountId$',
    IntegratorKey = '$IntegratorKey$',
    DocuSignAccountPassword = '$DocuSignAccountPassword$',
    DocuSignCertInDoc = '$DocuSignCertInDoc$',
    DocuSignPurgeCompletedDoc = '$DocuSignPurgeCompletedDoc$',
    LMSURL = '$LMSURL$',
    UseSponsorInboxSettings = '$UseSponsorInboxSettings$',
    InboxServer = '$InboxServer$',
    InboxEmailDomain = '$InboxEmailDomain$',
    AlfrescoInboxServerUrl = '$AlfrescoInboxServerUrl$',
    AlfrescoInboxUsername = '$AlfrescoInboxUsername$',
    AlfrescoInboxPassword = '$AlfrescoInboxPassword$',
    AlfrescoInboxDomainId = '$AlfrescoInboxDomainId$',
    AdobeSignRefreshToken = '$AdobeSignRefreshToken$',
    AdobeSignApplicationId = '$AdobeSignApplicationId$',
    AdobeSignSecretKey = '$AdobeSignSecretKey$',
    AdobeSignIsCfrPart11 = '$AdobeSignIsCfrPart11$',
    AdobeSignStoreCertInDoc = '$AdobeSignStoreCertInDoc$',
    AdobeSignPurgeDocAfterRetrive = '$AdobeSignPurgeDocAfterRetrive$',
    AdobeSignApiAccessPoint = '$AdobeSignApiAccessPoint$',
    AdobeSignWebAccessPoint = '$AdobeSignWebAccessPoint$',
    AdobeSignSignerIdentityVerification = '$AdobeSignSignerIdentityVerification$',
    UseSponsorNDDSettings = '$UseSponsorNDDSettings$',
    UseSponsorChecklistSettings = '$UseSponsorChecklistSettings$',
    UseSponsorMetadataExtractionSettings = '$UseSponsorMetadataExtractionSettings$',
    EnableMetadataExtraction = '$EnableMetadataExtraction$',
    ConfidenceScoreDocType = '$DocumentConfidenceScoreDocType$',
    ConfidenceScoreInvSite = '$DocumentConfidenceScoreInvSite$',
    ConfidenceScoreContact = '$DocumentConfidenceScoreContact$',
    ConfidenceScoreAdditionalFields = '$DocumentConfidenceScoreAdditionalFields$',
    ConfidenceScoreMedium = '$DocumentConfidenceScoreMedium$',
    ConfidenceScoreHigh = '$DocumentConfidenceScoreHigh$',
    TIAnalyticsEnabled = '$TIAnalyticsEnabled$',
  }

  export enum InvestigativeSiteReport {
    VisitDate = '$VisitDate$',
    VisitTypeId = '$VisitTypeId$',
    VisitTypeName = '$$VisitTypeName$$',
    InvestigativeSiteId = '$InvestigativeSiteId$',
    InvestigativeSiteName = '$$InvestigativeSiteName$$',
    ContactName = '$$ContactName$$',
    VisitSummary = '$VisitSummary$',
    DocumentsMissingInSiteBinder = '$DocumentsMissingInSiteBinder$',
    NotApplicableDocuments = '$DocumentsMissingInEtmf$',
    DocumentsMissingInEtmfAndSiteBinder = '$DocumentsMissingInSiteBinderAndEtmf$',
    CreatedBy = '$$CreatedBy$$',
    CreatedDate = '$$CreatedDate$$',
    Comments = '$Comments$',
  }

  export enum InvestigativeSite {
    UpdateAddressFieldsRequired = '$$UpdateAddressFieldsRequired$$',
    AccessRight = 'Access Right',
    SiteNumber = 'SiteNumber',
    SiteGroupId = 'SiteGroupId',
    Country = 'Country',
    ExpirationDate = 'ExpirationDate',
    DisplayName = 'DisplayName',
    TopicName = 'TopicName',
    Address = 'Address',
    Address2 = 'Address2',
    Address3 = 'Address3',
    City = 'City',
    State = 'State',
    ZipCode = 'ZipCode',
    GeoCode = '$GeoCode$',
    Phone = 'Phone',
    Fax = 'Fax',
    Website = 'Website',
    EmailAddress = '$EmailAddress$',
    Prefix = 'prefix',
    OtherPhone = '$OtherPhone$',
    Status = 'StatusId',
    StatusVirtual = '$$Status$$',
    IRBType = '$$IRBType$$', // virtual, UI only
    IRBTypeField = 'IRBType',
    IRBId = 'IRBId',
    IRBSubmitDate = 'IRBSubmitDate',
    CanChangeNonParticipaitingStatus = '$$CanChangeNonParticipaitingStatus$$',
    SiteEmailDomains = '$SiteEmailDomains$',
    PartialRegulatoryApproval = 'PartialRegulatoryApproval',
    FullRegulatorySubmission = 'FullRegulatorySubmission',
    FullRegulatoryApproval = 'FullRegulatoryApproval',
    SiteContractFinalized = 'SiteContractFinalized',
    RegulatoryApprovalStatus = 'RegulatoryApprovalStatus',
    RegulatoryApprovalRequest = 'RegulatoryApprovalRequest',
    ProjectedContractApprovalDate = 'ProjectedContractApprovalDate',
    PrincipalInvestigator = '$$PrincipalInvestigator$$', // virtual
    PrincipalInvestigatorId = 'PrincipalInvestigatorId', // virtual
    PrincipalInvestigatorFirstName = 'PrincipalInvestigatorFirstName',
    PrincipalInvestigatorLastName = '$$PrincipalInvestigatorLastName$$',
    SponsorContact = '$$CRA$$', // virtual
    StartupSpecialist = '$$StartupSpecialist$$', // virtual
    MainContact = '$$MainContact$$', // virtual, UI only
    MainContactPhone = '$$MainContactPhone$$', // virtual, UI only
    GroupMembers = 'GroupMembers', // virtual, UI only
    PreferredCommunicationMode = 'PreferredCommunicationMode',
    ApprovalProgress = '$$EssentialDocumentsApprovedPercent$$',
    SponsorId = 'SponsorId',
    AutoSiteName = '$AutoSiteName$',
    AutoSiteNameManualUpdate = '$AutoSiteNameManuallyUpdate$',
    AutoSiteNameDisablingReason = '$AutoSiteNameDisablingReason$',
    AutoSiteNameLastUpdatedBy = '$$AutoSiteNameLastUpdatedBy$$',
    PendingNonEssentialDocumentsCount = '$$PendingNonEssentialDocumentsCount$$',
    NextPreSubmissionDeadlineDate = 'NextPreSubmissionDeadlineDate',
    ExpectedSubmissionDate = 'ExpectedSubmissionDate',
    ProjectedIRBApprovalDate = 'ProjectedIRBApprovalDate',
    IRBApprovalDate = 'IRBApprovalDate',
    ProjectedSiteActivationDate = 'ProjectedSiteActivationDate',
    SiteActivationDate = 'SiteActivationDate',
    SiteActivationComments = 'SiteActivationComments',
    RegPackSentDate = 'RegPackSentDate',
    RegPackEDelivery = 'RegPackEDelivery',
    ReaderGroupId = 'ReaderGroupId',
    EditorGroupId = 'EditorGroupId',
    NonParticipatingSite = 'NonParticipatingSite',
    ClosedSite = '$ClosedSite$',
    ReasonForSiteNotParticipating = 'ReasonForSiteNotParticipating',
    EFeasibilityStatus = 'EFeasibilityStatusId',
    IrbNumber = '$IRBNumber$',
    MyFavorite = '$$MyFavorite$$',
    MyFavoriteComments = '$$MyFavoriteComments$$',
    ShouldUpdateUserFields = '$$ShouldUpdateUserFields$$',
    EffectiveClosureDate = '$EffectiveClosureDate$',
    ClosingComments = '$ClosingComments$',
    ProtectedDocsGroupId = '$ProtectedDocsGroupId$',
    CRAGroupId = '$CRAGroupId$',
    OthersGroupId = '$OthersGroupId$',
    InvestigativeSitePin = '$$InvestigativeSitePin$$',
    NotInheritSecurityFromTemplateFolders = '$NotInheritSecurityFromTemplateFolders$',
    SiteStatusChangeDate = '$SiteStatusChangeDate$',
    IRBName = '$$IRBName$$',
    CountryApprovalDate = 'CountryApprovalDate',
    StatusDate = '$StatusDate$',
    StatusComments = '$StatusComments$',
    IsCurrentUserStartupSpecialist = '$$IsCurrentUserStartupSpecialist$$',
    IsInvestigativeSiteFinalized = '$IsInvestigativeSiteFinalized$',

    InvestigativeSiteId = '$InvestigativeSiteId$',
    InvestigativeSiteName = '$$InvestigativeSiteName$$',
    InvestigativeSiteCountry = '$$InvestigativeSiteCountry$$',
    InvestigativeSiteCRA = '$$InvestigativeSiteCRA$$',
    StatusId = '$StatusId$',
    StatusName = '$$StatusName$$',
    CountryDataRoomTopicId = '$$CountryDataRoomTopicId$$',
    OverdueMilestonesCount = '$$OverdueMilestonesCount$$',

    RiskLevel = '$$RiskLevel$$',
    RiskScore = '$$RiskScore$$',
    MissingLevel = '$$MissingLevel$$',
    MissingScore = '$$MissingScore$$',
    TimelinessLevel = '$$TimelinessLevel$$',
    TimelinessScore = '$$TimelinessScore$$',
    QualityLevel = '$$QualityLevel$$',
    QualityScore = '$$QualityScore$$',
  }

  export enum InvestigativeSiteSSUOptions {
    Approvers = 'Approvers',
    CurrentUserCanActivateReject = 'CurrentUserCanActivateReject',
    IsCurrentUserStartupSpecialist = 'IsCurrentUserStartupSpecialist',
    IsCurrentUserSSUApprover = 'IsCurrentUserSSUApprover',
    IsEntityFrozen = 'IsEntityFrozen',
    LocalApproversGroupId = 'LocalApproversGroupId',
    RegulatoryApprovalRequestSent = 'RegulatoryApprovalRequestSent',
  }

  export enum DocumentType {
    IncludeInChangeControlWorkflow = '$IncludeInChangeControlWorkflow$',
    CtmsDocTypeId = '$CTMSDocTypeId$',
    IrbDocTypeId = '$IRBDocTypeId$',
    DocTypeId = '$DocTypeId$',
    IndividualIds = 'IndividualIds',
    AssociationLevel = 'AssociationLevel',
    FolderId = 'FolderId',
    DocumentCategoryId = 'DocumentCategoryId',
    DocumentTypeShortName = 'DocumentTypeShortName',
    SortOrder = 'Sort Order',
    SearchKeywords = 'SearchKeywords',
    DocumentTypeNamingPattern = 'DocumentTypeNamingPattern',
    IsStudySpecific = 'IsStudySpecific',
    TemplateFileName = '$$TemplateFileName$$',
    CodingTypeName = '$$CodingTypeName$$',
    Index = '$$Index$$',
    Hierarchy = '$$Hierarchy$$',
    IncludeInDocumentTrackerReport = 'IncludeInDocumentTrackerReport',
    IncludeInMonitoringVisits = '$IncludeInMonitoringVisits$',
    // RequireESignature = '$RequireESignature$', // not used since we're using the DocuSign
    EsignaturePurpose = '$EsignaturePurpose$',
    DueDate = 'DueDate',
    Milestones = '$Milestones$',
    EventTypes = '$EventTypes$',
    SiteStatus = '$InvestigativeSiteStatusIds$',
    ResponsibleDepartmentId = '$$TeamId$$',
    ResponsiblePartyTypeId = '$ResponsiblePartyTypeId$',
    ResponsiblePartyType = '$$ResponsiblePartyType$$', // virtual
    ChildDocTypesCount = '$$ChildDocTypesCount$$',
    CWSMatchingDocumentTypeId = '$$CWSMatchingDocumentTypeId$$',

    UniversalId = '$UniversalId$',
    Zone = '$Zone$',
    Section = '$Section$',
    Artifact = '$Artifact$',
    SubArtifact = '$SubArtifact$',
    IndexNumber = '$IndexNumber$',
    Description = '$Description$',
    Instructions = '$Instructions$',
    HasImmediateRequiredDocs = '$$HasImmediateRequiredDocs$$',
    NextReviewPeriod = '$NextReviewPeriod$',
    PeriodicReviewNotRequired = '$PeriodicReviewNotRequired$',
    RelatedToOrganization = '$RelatedToOrganization$',
    RiskScore = '$RiskScore$',
  }

  export enum Milestone {
    SortOrder = 'SortOrder',
    Enabled = 'Enabled',
    CategoryId = 'CategoryId',
    MilestoneTypeId = 'MilestoneTypeId',
  }

  export enum EventType {
    SortOrder = 'SortOrder',
    Enabled = 'Enabled',
    CategoryId = 'CategoryId',
    NotApplicable = '$NotApplicable$',
    DaysForSubmission = '$DaysForSubmission$',
    Description = '$Description$',
  }

  export enum EventTrigger {
    EventTriggersCount = '$$EventTriggersCount$$',
    TriggerTypeId = '$TriggerTypeId$',
    TriggerEntityId = '$TriggerEntityId$',

    //Non-existing fields for UI logic only
    UIStatus = '$$UI$$Status$$',
  }

  export enum Site {
    EFeasibilityStatusId = 'EFeasibilityStatusId',
    EffectiveClosureDate = '$EffectiveClosureDate$',
    RegPackSentDate = 'RegPackSentDate',
    IRBSubmitDate = 'IRBSubmitDate',
    IRBApprovalDate = 'IRBApprovalDate',
    ProjectedIRBApprovalDate = 'ProjectedIRBApprovalDate',
    PreferredCommunication = 'PreferredCommunicationMode',
    AutoSiteName = '$AutoSiteName$',
    IsFavorite = '$$IsFavorite$$',
    RegReviewPendingDocCount = '$$RegReviewPendingDocCount$$',
    ExpiredDocCount = '$$ExpiredDocCount$$',
    ExpiringDocCount = '$$ExpiringDocCount$$',
    RejectedDocumentsCount = '$$RejectedDocumentsCount$$',
    EnableCTMSIntegration = '$EnableCTMSIntegration$',
    EnableLMSIntegration = '$LmsEnabled$',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    EnableEvents = '$LmsEnabled$',
    DocumentUploadExpected = '$DocumentUploadExpected$',
    ClientName = 'ClientName',
    ExpirationDate = '$$Billing_Billing.ExpirationDate$$', // virtual
    JobNumber = '$$Billing_Billing.JobNumber$$', // virtual
    SiteTypeId = 'SiteTypeId', // system
    SalesAssociate = 'SalesAssociate', // system
    UseAsSourceForCloning = 'UseAsSourceForCloning',
    SiteId = 'SiteId',
    CloningCategoryId = 'CloningCategoryId',
    IsClosed = '$IsClosed$',
    DeactivationDate = 'DeactivationDate',
    ClosingDate = '$ClosingDate$',
    ProgramId = '$ProgramId$',
    ProgramName = '$$ProgramName$$',
    LegalHoldStartDate = '$LegalHoldStartDate$',
    LegalHoldDueDate = '$LegalHoldDueDate$',
    LegalHoldReason = '$LegalHoldReason$',
    IrbId = '$IRBId$',
    ProtocolNumber = 'ProtocolNumber',
    Indication = '$Indication$',
    Country = '$Country$',
    StudySponsor = '$StudySponsor$',
    CRO = '$CRO$',
    UseAsSharedWorkspace = '$UseAsSharedWorkspace$',
    SharedWorkspace = '$SharedWorkspaceId$',
    LastVisit = '$$LastVisit$$',
    SiteIdVirtual = '$$SiteId$$',
    ParentIdVirtual = '$$ParentId$$',
    SiteName = '$$SiteName$$',
    Description = '$$Description$$',
    Status = '$$Status$$',
    SalesAssociateName = '$$SalesAssociate$$',
    IndustryName = '$$Industry$$',
    InstitutionalReviewBoard = 'InstitutionalReviewBoard',
    RegionName = '$$Region$$',
    SponsorId = 'SponsorId',
    SponsorName = '$$Sponsor$$',
    StudyId = '$StudyId$',
    StudyName = '$$StudyName$$',
    UseAsSourceForCloningName = '$$UseAsSourceForCloning$$',
    ClonedFromRoomName = '$$ClonedFromRoom$$',
    ClonedFromSiteId = 'ClonedFromSiteId',
    CloningCategoryName = '$$CloningCategory$$',
    IsClosedName = '$$IsClosed$$',
    GlobalSSUApproversGroupName = '$$GlobalSSUApproversGroup$$',
    IrbName = '$$IRB$$',
    UseAsSharedWorkspaceName = '$$UseAsSharedWorkspace$$',
    SharedWorkspaceName = '$$SharedWorkspace$$',
    SiteTypeName = '$$SiteType$$',
    CreatedByName = '$$CreatedBy$$',
    CreatedDate = '$$CreatedDate$$',
    eTMF = '$$eTMF$$',
    StartUp = '$$SSU$$',
    TotalPageCount = '$$TotalPageCount$$',
    TotalDocumentCount = '$$TotalDocumentCount$$',
    TotalDocumentsSize = '$$TotalDocumentsSize$$',
    ProjectCode = 'ProjectCode',
    RoomToCloneConfiguration = 'RoomToCloneConfiguration',
    RoomClassificationId = '$RoomClassificationId$',
    InvestigativeSiteCount = '$$InvestigativeSiteCount$$',
    EnableEtmf = '$$EnableEtmf$$',
    BusNotifyStatus = '$BusNotifyStatus$',
    CountriesCount = '$$CountriesCount$$',
    ActiveSitesCount = '$$ActiveSitesCount$$',
    PendingSitesCount = '$$PendingSitesCount$$',
    DocumentQueryCount = '$$DocumentQueryCount$$',
    FinalDocumentCount = '$$FinalDocumentCount$$',
    SourceSiteIdForCloning = '$$SourceSiteIdForCloning$$',
    Region = 'Region',
    Industry = 'Industry',
    Phase = '$Phase$',
    ServiceOffering = '$ServiceOffering$',
    CollectedDocCount = '$$CollectedDocCount$$',
    MissingDocCount = '$$MissingDocCount$$',
    RequireCodingDocCount = '$$RequireCodingDocCount$$',
    StatusId = '$$StatusId$$',
    StatusIdSUU = 'StatusId',
    RoomTypeId = '$RoomTypeId$',
    RoomTypeName = '$$RoomType$$',
    ResponsibleParty = '$ResponsibleParty$',
    CloneInvSitesFromSiteId = 'CloneInvSitesFromSiteId',
    ProjectJobNumber = 'Billing.JobNumber',
    Project = 'Project',
    TherapeuticAreaId = 'TherapeuticAreaId',
    RoomFolder = 'RoomFolder',
    Milestones = 'Milestones',
    GeneralRoomOptions = 'GeneralRoomOptions',
    LinkRoom = 'LinkRoom',
    CopyIndexFromSource = 'CopyIndexFromSource',
    IncludeCustomReports = 'IncludeCustomReports',
    EmailSender = 'EmailSender',
    InboxDomain = 'InboxDomain',
    EnableInbox = 'EnableInbox',
    EnableCommunicationInbox = 'EnableCommunicationInbox',
    EnableSsuInbox = 'EnableSsuInbox',
    AcceptEmailFrom = 'AcceptEmailFrom',
    LastUpdatedBy = '$$LastUpdatedBy$$',
    LastUpdatedDate = '$$LastUpdatedDate$$',
    AddedBy = '$$AddedBy$$',
    FilterValue = '$$FilterValue$$',
    RoomsCount = '$$RoomsCount$$',
    RoleLevel = '$$RoleLevel$$',
    UnblindedRoom = '$UnblindedRoom$',

    CollectedDocPercentage = '$$CollectedDocPercentage$$',
    MissingDocPercentage = '$$MissingDocPercentage$$',
    RequireCodingDocPercentage = '$$RequireCodingDocPercentage$$',
    FinalDocumentPercentage = '$$FinalDocumentPercentage$$',
    ExpiredDocPercentage = '$$ExpiredDocPercentage$$',
    ExpiringDocPercentage = '$$ExpiringDocPercentage$$',
    DocumentQueryPercentage = '$$DocumentQueryPercentage$$',
    RejectedDocumentsPercentage = '$$RejectedDocumentsPercentage$$',

    AddDocuments = '$$AddDocuments$$',
    AddUser = '$$AddUser$$',
    AddTask = '$$AddTask$$',
    AddSite = '$$AddSite$$',
    AddEvent = '$$AddEvent$$',
    PeriodicReviewDocCount = '$$PeriodicReviewDocCount$$',
    WaitingESignatureDocCount = '$$WaitingESignatureDocCount$$',
    ESignatureInProgressDocCount = '$$ESignatureInProgressDocCount$$',

    HasChild = '$$HasChild$$',
    MobileAccessEnabled = '$MobileAccessEnabled$',
    CompanyCode = '$$CompanyCode$$',
    RoomName = 'RoomName',
    Comment = 'Comment',
    IsProgramCategory = 'IsProgramCategory',

    GeneralModuleEnableQueryResolution = '##General_Module.EnableQueryResolution##',
    GeneralModuleEnableAudit = '##General_Module.EnableAudit##',
    SecurityEsignatureUseEsignature = '##Security_Esignature.UseEsignature##',
    GeneralModuleEnableWorkflow = '##General_Module.EnableWorkflow##',
    GeneralModuleEnableETMF = '##General_Module.EnableETMF##',
  }

  export enum RoomType {
    Count = '$$Count$$',
    RoomTypeId = '$RoomTypeId$',
    Sortings = '$Sortings$',
    AdditionalKPIs = '$AdditionalKPIs$',
    KPIs = '$KPIs$',
    Actions = '$Actions$',
  }

  export enum Program {
    Name = 'Name',
    Description = 'Description',
    CreatedDate = 'CreatedDate',
    TherapeuticAreaId = 'TherapeuticAreaId',
    AdminGroupId = 'AdminGroupId',
    EditorGroupId = 'EditorGroupId',
    ReaderGroupId = 'ReaderGroupId',
    ProgramSiteId = 'ProgramSiteId',
    StatusId = '$StatusId$',
    ClosureReason = '$ClosureReason$',
    LegalHoldStartDate = '$LegalHoldStartDate$',
    LegalHoldDueDate = '$LegalHoldDueDate$',
    LegalHoldReason = '$LegalHoldReason$',
    LegalHoldBy = '$$LegalHoldBy$$',
    SponsorId = '$SponsorId$',
    Sponsor = 'SponsorId', // to use as the plain object field
    ProgramToCloneDataFrom = 'ProgramToCloneDataFrom',
  }

  export enum ProgramStatus {
    StatusId = '$StatusId$',
  }

  export enum StudyProfile {
    StudyId = '$StudyId$',
    ProtocolNumber = '$ProtocolNumber$',
    StudyName = '$StudyName$',
    SponsorId = '$SponsorId$',
    CompanyName = '$ClientName$',
    HasRooms = '$$HasRooms$$',
    StatusId = '$StatusId$',
    Status = '$$Status$$',
    StatusDate = '$StatusDate$',
    StatusComments = '$StatusComments$',
    DisableCommonDataSync = '$DisableCommonDataSync$',
  }

  export enum Translations {
    StatusId = '$$StatusId$$',
    StatusName = '$$StatusName$$',
    ProtocolNumber = '$ProtocolNumber$',
    StudyName = '$StudyName$',
    SponsorId = '$SponsorId$',
    CompanyName = '$ClientName$',
    TargetLanguages = '$$TargetLanguages$$',
    FolderId = '$$FolderId$$',
    DropCertificatesToFolderId = '$$DropCertificatesToFolderId$$',
    TransPortNo = '$TransPortNo$',
    CreatedBy = '$$CreatedBy$$',
    TransPortLink = '$$TransPortLink$$',
    DeadlineType = '$DeadlineType$',
    ExpectedDueDate = '$ExpectedDueDate$',
    RequestQuote = '$RequestQuote$',
    SourceLanguage = '$SourceLanguage$',
    SourceLanguageName = '$$SourceLanguageName$$',
    TranslationRequestId = '$$TranslationRequestId$$',
    DocumentName = '$$DocumentName$$',
    FileName = '$$FileName$$',
    SubmissionName = '$SubmissionName$',
    AdditionalInstructions = '$AdditionalInstructions$',
    ExternalStatusId = '$$ExternalStatusId$$',
  }

  export enum DocumentCategory {
    DocumentCategoryId = 'DocumentCategoryId', // system
    SortOrder = 'SortOrder', // system
  }

  export enum Folder {
    FolderHierarchyIds = '$$FolderHierarchyIds$$',
    FolderCount = 'Folder Count',
    TotalDocumentCount = 'Total Document Count',
    DocumentCount = 'Document Count',
    SortOrder = 'SortOrder',
    IndexPath = '$$IndexPath$$',
    DefaultInvestigativeSiteFolderId = 'DefaultInvestigativeSiteFolderId',
    InvestigativeSiteId = 'InvestigativeSiteId',
    Iso2 = '$$Iso2$$',
    AclHash = '$$AclHash$$',
  }

  export enum WorkflowReviewStatus {
    WorkflowStatusTypeId = 'WorkflowStatusTypeId',
    StatusColorId = 'StatusColorId',
  }

  export enum Irb {
    Address = 'Address',
    Address2 = 'Address2',
    Address3 = 'Address3',

    InvestigativeSiteId = 'InvestigativeSiteId',
    DomainIRBId = 'DomainIRBId',
    $IRBTypeId$ = '$IRBTypeId$',
    ApprovalInterval = 'ApprovalInterval',
    BufferTime = 'BufferTime',
    City = 'City',
    Country = 'Country',
    InstitutionalName = 'IRBName',
    SitesNumber = '$$SitesNumber$$',
    InstitutionalType = 'IRBType',
    IRBInInvestigativeSiteType = '$$IRBInInvestigativeSiteType$$',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    IRBTypeId = '$IRBTypeId$',
    SubmissionDeadline = 'SubmissionDeadline',
    MeetingFrequency = 'MeetingFrequency',
    SubmissionDeadlineInterval = 'SubmissionDeadlineInterval',
    ApprovalProgress = '$$EssentialDocumentsApprovedPercent$$',
    Region = 'Region',
    EnableIRBIntegration = '$EnableIRBIntegration$',
    IsFavorite = '$$IsFavorite$$',
    StatusName = '$$StatusName$$',

    SubmissionDate = 'IRBSubmitDate',
    Status = 'Status',
    StatusComments = '$StatusComments$',
    StatusDate = '$StatusDate$',
    IRBApprovalDate = 'IRBApprovalDate',
    State = 'State',
    ZipCode = 'ZipCode',

    Website = 'Website',
    Phone = 'Phone',
    Email = 'Email',
    IsIRBFinalized = '$IsIRBFinalized$',

    IRBApprovalDateSiteLevel = '$IRBApprovalDate$',
    IRBSubmitDateSiteLevel = '$IRBSubmitDate$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
  }

  export enum Committee {
    PreSubmissionDeadline = 'PreSubmissionDeadline',
    PreMeetingDate = 'PreMeetingDate',
    MeetingDate = 'MeetingDate',
    Dependency = 'Dependency',
    ApprovalInterval = 'ApprovalInterval',
  }

  export enum User {
    Locale = 'Locale',
    TimeZone = 'TimeZone',
    CustomDateFormat = 'CustomDateFormat',
    MainContact = 'MainContact', // system,
    ProvideDocuments = 'ProvideDocuments',
    IsExternalAuditor = 'IsExternalAuditor',
    Organization = '$$Organization$$',
    OrganizationName = '$$OrganizationName$$',
    OrganizationId = 'OrganizationId',
    ClientOrganizationId = '$ClientOrganizationId$',
    ClientOrganizationName = '$$ClientOrganizationName$$',
    ShowSSSInvSites = 'ShowOnlySSSInvSites',
    UserZoom = 'UserZoom',
    RecentSearchFields = 'UserData.RecentSearchFields',
    RecentSearches = 'UserData.RecentSearches',
    RecentSearchesSSU = 'UserData.RecentSearchesSSU',
    QuestionsAnswers = 'UserData.QuestionsAnswers',
    MuteMaintenanceBanner = 'UserData.MuteMaintenanceBanner',
    PreviousMaintenanceBannerHash = 'UserData.PreviousMaintenanceBannerHash',

    FirstName = '$$FirstName$$',
    LastName = '$$LastName$$',
    EmailAddress = '$$EmailAddress$$',
    PhoneNo = '$$PhoneNo$$',
    MobileNo = '$$MobileNo$$',
    FullName = '$$FullName$$',
    StatusId = '$$StatusId$$',
    RoleLevel = '$$RoleLevel$$',
    SsoEnabled = '$$SsoEnabled$$',
    UserId = '$$UserId$$',
    UserName = '$$UserName$$',
    MFARegistered = '$MFARegistered$',
    Title = '$$Title$$',
    Address = '$$Address$$',
    City = '$$City$$',
    State = '$$State$$',
    ZipCode = '$$ZipCode$$',
    Country = '$$Country$$',
    IsLocked = '$$IsLocked$$',

    ContactStatus = 'ContactStatus',
    InvestigativeSiteName = 'InvestigativeSiteName',
    ContactTypeName = 'ContactTypeName',
    IsUserMainContact = 'IsUserMainContact',
    ContactType = 'ContactType',
    SameAsInvSiteAddress = 'SameAsInvSiteAddress',
    Prefix = 'Prefix',
    Suffix = 'Suffix',
    MiddleName = 'MiddleName',
    ClinicalTrialExperience = 'ClinicalTrialExperience',
    SitesCount = '$$SitesCount$$',
    UserGroups = '$$UserGroups$$',
    UserTeams = '$$UserTeams$$',

    Country2 = 'Country',
    Address2 = 'Address',
    City2 = 'City',
    State2 = 'State',
    ZipCode2 = 'ZipCode',
    FullName2 = 'FullName',
    StatusId2 = 'StatusId',
    EmailAddress2 = 'EmailAddress',
    FirstName2 = 'FirstName',
    LastName2 = 'LastName',
    MobileNo2 = 'MobileNo',
    PhoneNo2 = 'PhoneNo',
    IsRegistered = '$$IsRegistered$$',

    SponsorContactId = '$SponsorContactId$',
    SponsorUserId = '$SponsorUserId$',
  }

  export enum Contact {
    UserId = '$UserId$',
    UserIdVirtual = '$$UserId$$',
    ContactStatusId = '$$ContactStatusId$$',
    StatusId = '$$StatusId$$',
    RoleLevel = '$$RoleLevel$$',
    ProvideDocuments = '$$ProvideDocuments$$',
    ProvideDocumentsSSU = '$ProvideDocuments$',
    UserName = '$$UserName$$',
    EmailAddress = '$$EmailAddress$$',
    FirstName = '$$FirstName$$',
    LastName = '$$LastName$$',
    FullName = '$$FullName$$',
    Address = '$$Address$$',
    City = '$$City$$',
    State = '$$State$$',
    ZipCode = '$$ZipCode$$',
    Country = '$$Country$$',
    PhoneNo = '$$PhoneNo$$',
    MobileNo = '$$MobileNo$$',
    Active = '$$Active$$',
    MainContact = '$$MainContact$$',
    MainContactSSU = '$MainContact$',
    ContactTypeName = '$$ContactTypeName$$',
    InvestigativeSiteName = '$$InvestigativeSiteName$$',
    SiteId = '$$SiteId$$',
    SiteName = '$$SiteName$$',
    Prefix = '$$Prefix$$',
    Suffix = '$$Suffix$$',
    ClinicalTrialExperience = '$$ClinicalTrialExperience$$',
    StudyId = '$$StudyId$$',
    StudyName = '$$StudyName$$',
    StudyTopicId = '$$StudyTopicId$$',
    ContactTypeId = '$ContactTypeId$',
    ContactType = 'ContactType',
    ContactTypeGroupId = '$ContactTypeGroupId$',
    ContactStatusDate = '$$ContactStatusDate$$',
    ContactStatusComments = '$$ContactStatusComments$$',
    MiddleName = '$$MiddleName$$',
    ContactTypeCategoryId = '$$ContactTypeCategoryId$$',
    InvestigativeSiteId = '$InvestigativeSiteId$',
    InvestigativeSiteDomainId = '$$InvestigativeSiteDomainId$$',
    IAMUserId = '$$IAMUserId$$',
    StartDate = '$StartDate$',
    EndDate = '$EndDate$',
    ReceiveAcknowledgementNotification = '$ReceiveAcknowledgementNotification$',
    SponsorContactId = '$$SponsorContactId$$',
    StudySiteUser = '$$StudySiteUser$$',
    Title = '$$Title$$',
  }

  export enum Topic {
    TopicName = '$$TopicName$$',
    TopicTypeId = '$$TopicTypeId$$',
    Enabled = 'Enabled', // This constant added to use it with TypifiedTopicGrid with 'Enabled' column turned on.
  }

  export enum CommunicationLog {
    ContactDate = 'ContactDate',
    CommunicationTypeId = 'CommunicationTypeId',
    NextContactDate = 'NextContactDate',
    Description = 'Description',
    CreatedBy = '$$CreatedBy$$',
    CreatedById = 'CreatedBy',
    // InvestigativeSite = '$$InvestigativeSite$$',
    CommunicationEntity = '$$CommunicationEntity$$',
    CommunicationType = '$$CommunicationType$$',
    ContactId = 'ContactId',
    ContactName = '$$ContactName$$',
    Site = '$$SiteName$$',
    Level = '$$Level$$',
  }

  export enum Country {
    Country = 'Country',
    StudyContact = 'StudyContact',
    isAnySiteActivated = '$$IsAnySiteActivated$$',
    ApprovalProgress = '$$EssentialDocumentsApprovedPercent$$',
    AgencySubmissionProgressPercent = '$$AgencySubmissionProgressPercent$$',
    ExpectedApprovalDate = 'ExpectedApprovalDate',
    Comments = 'Comments',
    StatusComments = '$StatusComments$',
    StatusDate = '$StatusDate$',
    TrackAgencySubmissionProgress = '$TrackAgencySubmissionProgress$',
    ReaderGroupId = 'ReaderGroupId',
    EditorGroupId = 'EditorGroupId',

    Status = 'Status',
    StatusName = '$$StatusName$$',
    ApprovedDate = 'ApprovedDate',
    RejectionDate = '$RejectionDate$',
    SubmissionDate = '$SubmissionDate$',
    ClosedDate = '$ClosedDate$',
    OnHoldDate = '$OnHoldDate$',
    NonParticipatingDate = '$NonParticipatingDate$',
    IsFavorite = '$$IsFavorite$$',
    Language = '$Language$',
    SitesNumber = '$$SitesNumber$$',
    CountryName = '$$CountryName$$',
    LanguageName = '$$LanguageName$$',
    IsCountryFinalized = '$IsCountryFinalized$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
    CTISStatus = '$$CTISStatus$$',
  }

  export enum CountryInDataRoom {
    ExpectedApprovalDate = 'ExpectedApprovalDate',
    Status = 'Status',
    ApprovedDate = 'ApprovedDate',
    Comments = 'Comments',
    SSUApproverGroupId = '$SSUApproverGroupId$',
    RejectionDate = '$RejectionDate$',
    SubmissionDate = '$SubmissionDate$',
    ClosedDate = '$ClosedDate$',
    OnHoldDate = '$OnHoldDate$',
    NonParticipatingDate = '$NonParticipatingDate$',
    StatusDate = '$$StatusDate$$',
    CTISStatus = '$$CTISStatus$$',
    OverdueMilestonesCount = '$$OverdueMilestonesCount$$',
  }

  export enum Tasks {
    Subject = 'Subject',
    StartDate = 'StartDate',
    DueDate = 'DueDate',
    Status = 'StatusId',
    Category = 'CategoryId',
    CategoryName = '$$CategoryName$$',
    Priority = 'Priority',
    CompletePercent = 'CompletePercent',
    Owner = '$$CreatedBy$$',
    Assign = '$$AssignedTo$$',
    CommunicationLogId = 'CommunicationLogId',
    AssignedToIds = 'AssignedToIds',
    Description = 'Description',
    Reminder = 'Reminder',
    IsReminderSent = 'IsReminderSent',
    SiteId = 'DataRoomId',
    CreatedDate = '$$CreatedDate$$',
    LastUpdatedBy = '$$LastUpdatedBy$$',
    LastUpdatedDate = '$$LastUpdatedDate$$',
    AttachmentsCount = 'AttachmentsCount',
    Attachments = 'Attachments',
    Documents = 'Documents',
    Tags = '$Tags$',
  }

  export enum ClientOrganization {
    Number = '$Number$',
    Name = '$Name$',
    ClientName = '$$Name$$',
    TypeId = '$TypeId$',
    Type = '$$Type$$',
    SubTypeId = '$SubTypeId$',
    SubType = '$$SubType$$',
    StatusId = '$StatusId$',
    Status = '$$Status$$',
    StatusTypeId = '$$StatusTypeId$$',
    Countries = '$Countries$',
    Notes = '$Notes$',
    Description = '$Description$',
    Department = '$Department$',
    Risk = '$Risk$',
    Tier = '$Tier$',
    Address = '$Address$',
    Email = '$Email$',
    Phone = '$Phone$',
    LegalEntityName = '$LegalEntityName$',
    RegistrationNumber = '$RegistrationNumber$',
    TaxId = '$TaxId$',
    IsFavorite = '$$IsFavorite$$',
  }

  export enum ClientOrganizationStatus {
    StatusTypeId = 'StatusTypeId',
  }

  export enum ClientOrganizationInDataRoom {
    ServiceProvided = '$ServiceProvided$',
    StartDate = '$StartDate$',
    EndDate = '$EndDate$',
    Comments = '$Comments$',
    StatusDate = '$StatusDate$',
    StatusComments = '$StatusComments$',
  }

  export enum Audit {
    StatusId = '$StatusId$',
    Status = '$$Status$$',
    Comments = '$Comments$',
    AuditDate = '$$AuditDate$$',
    Auditor = '$$Auditor$$',
    IsFinal = '$IsFinal$',
    ContainsPhi = '$ContainsPHI$',
    ResponseComments = '$ResponseComments$',
    IsDocumentAvailableForWorkflow = '$$IsDocumentAvailableForWorkflow$$',
    IsDocumentAvailableForAudit = '$$IsDocumentAvailableForAudit$$',
    FailureReason = '$FailureReason$',
    FailureReasonVirtual = '$$FailureReason$$',
  }

  export enum AuditUserActivities {
    CreatedDateString = 'CreatedDateString',
    ObjectValue = 'ObjectValue',
    TextField = 'TextField',
    FullName = 'FullName',
    ActivityTypeId = 'ActivityTypeId',
  }

  export enum AuditStatus {
    AuditStatusTypeId = 'AuditStatusTypeId',
  }

  export enum InvestigativeSiteStatus {
    InvestigativeSiteStatusTypeId = 'StatusTypeId',
    Enabled = 'Enabled',
    Disabled = 'Disabled',
  }

  export enum SubmissionProfileStatus {
    SubmissionProfileStatusTypeId = 'StatusTypeId',
    TypeName = 'StatusTypeName',
  }

  export enum VisitStatus {
    StatusTypeId = 'StatusTypeId',
  }

  // noinspection TsLint
  export enum eSignature {
    SignerName = '$SignerName$',
    SignatureDate = '$SignatureDate$',
    SortOrder = '$SortOrder$',
    CanStartSigning = '$CanStartSigning$',
    LoginName = '$LoginName$',
    Comments = '$Comments$',
    Reason = '$Reason$',
  }

  export enum Templates {
    Description = '$Description$',
    CategoryId = '$CategoryId$',
    CategoryName = '$$CategoryName$$',
    Countries = '$Countries$',
    AttachmentId = '$$AttachmentId$$',
    AttachmentName = '$$AttachmentName$$',
    DocumentTypeId = '$DocumentTypeId$',
    DocumentTypeName = '$$DocumentTypeName$$',
    InvestigativeSites = '$InvestigativeSites$',
    CollectionTypeId = '$CollectionTypeId$',
    HasPlaceholders = '$HasPlaceholders$',
  }

  export enum ProjectLinks {
    Url = '$Url$',
    Phone = '$Phone$',
    Email = '$Email$',
    Description = '$Description$',
    AttachmentId = '$$AttachmentId$$',
    AttachmentName = '$$AttachmentName$$',
    SharedToEveryone = '$SharedToEveryone$',
  }

  export enum AmendmentProfile {
    Description = '$Description$',
    AmendmentDate = '$AmendmentDate$',
    Scope = '$Scope$',
    Name = '$$TopicName$$',
    IsFavorite = '$$IsFavorite$$',
    CreatedDate = '$$CreatedDate$$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
    EssentialDocumentsApprovedPercent = '$$EssentialDocumentsApprovedPercent$$',
    RequiredBy = 'RequiredBy',
  }

  export enum InvestigativeSiteAmendment {
    AmendmentProfileId = '$AmendmentProfileId$',
    EssentialDocumentsApprovedPercent = '$$EssentialDocumentsApprovedPercent$$',
    InstitutionName = '$$InstitutionName$$',
    SiteNumber = '$$SiteNumber$$',
    PrincipalInvestigator = '$$PrincipalInvestigator$$',
    Status = '$StatusId$',
    AmendmentDate = '$$AmendmentDate$$',
    StatusName = '$$StatusName$$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
    AmendmentProfileName = '$$AmendmentProfileName$$',
    CreatedDate = '$$CreatedDate$$',
    Description = '$$Description$$',
    Name = 'Name',
    IsFavorite = '$$IsFavorite$$',
    NotApplicable = '$NotApplicable$',
    NotApplicableReason = '$NotApplicableReason$',
  }

  export enum IRBAmendment {
    Name = 'Name',
    IsFavorite = '$$IsFavorite$$',
    AmendmentProfileId = '$$AmendmentProfileId$$',
    EssentialDocumentsApprovedPercent = '$$EssentialDocumentsApprovedPercent$$',
    IRBName = '$$IRBName$$',
    IRBType = '$$IRBType$$',
    Status = '$StatusId$',
    AmendmentDate = '$$AmendmentDate$$',
    StatusName = '$$StatusName$$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
    AmendmentProfileName = '$$AmendmentProfileName$$',
    CreatedDate = '$$CreatedDate$$',
    Description = '$$Description$$',
  }

  export enum CountryAmendment {
    Name = 'Name',
    IsFavorite = '$$IsFavorite$$',
    AmendmentProfileId = '$AmendmentProfileId$',
    EssentialDocumentsApprovedPercent = '$$EssentialDocumentsApprovedPercent$$',
    Country = '$$Country$$',
    Status = '$StatusId$',
    AmendmentDate = '$$AmendmentDate$$',
    StatusName = '$$StatusName$$',
    RequiredDocumentsCount = '$$RequiredDocumentsCount$$',
    AmendmentProfileName = '$$AmendmentProfileName$$',
    CreatedDate = '$$CreatedDate$$',
    Description = '$$Description$$',
    CurrentUserCanCompleteAmendment = '$$CurrentUserCanCompleteAmendment$$',
    NotApplicableReason = '$NotApplicableReason$',
  }

  export enum GenericAmendment {
    AmendmentProfileId = '$$AmendmentProfileId$$',
    AmendmentProfileIdMain = 'AmendmentProfileId',
  }

  export enum SitesDraft {
    TiProtocolId = '$ProtocolId$',
    TiProtocolNumber = '$ProtocolNumber$',
    IrbNumber = '$IRBNumber$',
    PiLastname = '$PILastName$',
    PiFirstname = '$PIFirstName$',
    SiteName = '$InvestigativeSiteName$',
    SiteCity = '$InvestigativeSiteCity$',
    SiteState = '$InvestigativeSiteState$',
    SiteZipCode = '$InvestigativeSiteZipCode$',
    SiteCountry = '$InvestigativeSiteCountry$',
    StatusId = '$StatusId$',
    RelatedEntityTypeId = '$RelatedEntityTypeId$',
    DeleteReason = '$DeleteReason$',
    ErrorCode = '$ErrorCode$',
  }

  export enum HealthAgency {
    Country = 'Country',
    Address = 'Address',
    City = 'City',
    State = 'State',
    ZipCode = 'ZipCode',
  }

  export enum SubmissionProfile {
    Country = '$Country$',
    CountryName = '$$CountryName$$',
    AgencyId = '$AgencyId$',
    AgencyName = '$$AgencyName$$',
    SubmissionDate = '$SubmissionDate$',
    DocumentsCount = '$$DocumentsCount$$',
    SubmissionStatusId = '$SubmissionStatusId$',
    SubmissionStatusTypeId = '$$SubmissionStatusTypeId$$',
    SubmissionStatusName = '$$SubmissionStatusName$$',
    SubmissionType = '$SubmissionType$',
    Comments = '$Comments$',
    Title = '$$TopicName$$',
    LinkedDocuments = 'LinkedDocuments',
    UploadedDocuments = 'UploadedDocuments',
    TopicName = 'TopicName',
    StatusDate = '$StatusDate$',

    IrbId = '$IrbId$',
    IrbName = '$$IrbName$$',
    StatusComments = '$StatusComments$',
    InvestigativeSiteNames = '$$InvestigativeSiteNames$$',
    SitesProcessedProgressPercent = '$$SitesProcessedProgressPercent$$',
  }

  export enum SubmissionProfileDocumentPlaceholder {
    PlaceholderTitle = '$PlaceholderTitle$',
    SortOrder = '$PlaceholderSortOrder$',
  }

  export enum IRBSubmissionProfile {
    IrbName = '$$IrbName$$',
    IrbId = '$IrbId$',
    InvestigativeSiteNames = '$$InvestigativeSitesNames$$',
    InvestigativeSitesCount = '$$InvestigativeSitesCount$$',
    SitesProcessedProgressPercent = '$$SitesProcessedProgressPercent$$',
    StatusDate = '$StatusDate$',
    DocumentsCount = '$$DocumentsCount$$',
  }

  export enum SubmissionProfileSite {
    InvestigativeSiteId = '$InvestigativeSiteId$',
    StatusDate = '$StatusDate$',
    StatusId = '$StatusId$',
    StatusName = '$$StatusName$$',
    StatusComments = '$StatusComments$',
    InvestigativeSiteName = '$$InvestigativeSiteName$$',
    InvestigativeSiteCountry = '$$InvestigativeSiteCountry$$',
    InvestigativeSiteCRA = '$$InvestigativeSiteCRA$$',
    InvestigativeSiteCRACount = '$$InvestigativeSiteCRACount$$',
    InvestigativeSiteSUS = '$$InvestigativeSiteSUS$$',
    InvestigativeSiteSUSCount = '$$InvestigativeSiteSUSCount$$',
    InvestigativeSiteDomainId = '$$InvestigativeSiteDomainId$$',

    InvestigativeSiteStatusId = '$$InvestigativeSiteStatusId$$', // fe only
    InvestigativeSiteStatusName = '$$InvestigativeSiteStatusLabel$$', // fe only
    InvestigativeSiteStatusDate = '$$InvestigativeSiteStatusDate$$', // fe only
  }

  export enum InboxEmail {
    Title = '$Title$',
    SenderName = '$SenderName$',
    DocumentDate = '$DocumentDate$',
    SenderAddress = '$SenderAddress$',
    Status = '$Status$',
    Comments = '$Comments$',
    Attachments = 'Attachments',

    CodingTypeId = '$CodingTypeId$',
    DocTypeId = '$DocTypeId$',
    DocumentTypeId = '$DocumentTypeId$',
    InvestigativeSiteId = '$InvestigativeSiteId$',
    DocumentStatusId = '$DocumentStatusId$',
    Country = '$Country$',
    AddedBy = '$$AddedBy$$',
  }

  export enum Workflow {
    Description = 'Description',
    FilterValue = 'FilterValue',
    Scope = 'Scope',
    SearchQuery = 'SearchQuery',
    Status = 'Status',
    Trigger = 'Trigger',
    Type = 'Type',
    FormType = 'FormType',
    WorkflowTypeId = 'WorkflowTypeId',
    AccessRight = 'Access Right',
    EnableLMSIntegration = '$EnableLMSIntegration$',
    DocumentTypes = '$$DocumentTypes$$',
    LastUpdatedBy = '$$LastUpdatedBy$$',
    LastUpdatedDate = '$$LastUpdatedDate$$',
  }

  export enum WorkflowStage {
    ProcessingType = 'ProcessingType',
  }

  export enum RequiredDocumentMetadata {
    DocumentCategory = '$$DocumentCategory$$',
    DocumentCategoryId = '$$DocumentCategoryId$$',
    DocumentType = '$$DocumentType$$',
    RequiredFor = 'RequiredFor',
    Contact = 'Contact',
    Language = 'Language',
    RequiredByName = '$$RequiredByName$$',
    ProvidedByName = '$$ProvidedByName$$',
    TriggerCriteria = 'TriggerCriteria',
  }

  export enum RoomLink {
    LinkedRoomId = '$LinkedRoomId$',
    Description = '$Description$',
    DestinationModule = '$DestinationModule$',
    Name = '$$Name$$',
    CanUserLogIn = '$$CanUserLogIn$$',
    RoomTypeId = '$$RoomTypeId$$',
  }

  export enum Event {
    Comments = '$Comments$',
    Description = '$Description$',
    Country = '$Country$',
    InvestigativeSiteId = 'InvestigativeSiteId',
    EventTypeId = '$EventTypeId$',
    StatusId = '$StatusId$',
    Category = '$$CategoryId$$',
    CategoryId = 'CategoryId',
    DaysForSubmission = '$DaysForSubmission$',
    CompletedDate = '$CompletedDate$',
    PlannedDate = '$PlannedDate$',
    SelectionCriteria = '$SelectionCriteria$',
    EventTypeName = '$$EventTypeName$$',
    NoDocumentsRequired = '$NoDocumentsRequired$',
    Progress = '$$Progress$$',
    ProgressHint = '$$ProgressHint$$',
    DueDate = '$DueDate$',
    NoDueDate = '$NoDueDate$',
    CloneStatusDate = '$CloneStatusDate$',
    EventNameTemplate = '$EventNameTemplate$',
    StartDate = '$StartDate$',
    VisitStatusId = '$VisitStatusId$',
    FromExternalSource = '$FromExternalSource$',
  }

  export enum ServiceOffering {
    Offering = '$Offering$',
  }

  export enum RelationshipType {
    ServiceOfferings = '$ServiceOfferings$',
    DocumentTypeIds = '$DocumentTypeIds$',
    SearchConditions = '$SearchConditions$',
    UIDocumentTypeNames = 'UIDocumentTypeNames',
    IsManual = '$IsManual$',
    ManualDocsCount = '$$ManualDocsCount$$',
    DocsCountVM0 = '$$DocsCountVM0$$',
    DocsCountVM2 = '$$DocsCountVM2$$',
  }

  export enum SaveSearch {
    EntityType = 'EntityType',
    Title = 'Title',
    Filters = 'Filters',
    Columns = 'Columns',
    SortOrder = 'SortOrder',
    Value = 'Value',
    Description = 'Description',
    StaticQuery = 'StaticQuery',
    SearchEntity = '$SearchEntity$',
    FtsQuery = '$FtsQuery$',
    FtsQueryMode = '$FtsQueryMode$',
    SearchInRoomIds = '$SearchInRoomIds$',
    AdvancedSearch = '$AdvancedSearch$',
    FacetedSearch = '$FacetedSearch$',
    IsFavorite = '$IsFavorite$',

    ShareType = '$$ShareType$$',
    OwnerName = '$$OwnerName$$',
    OwnerFullName = '$$OwnerFullName$$',
    UISearchDocTopics = '$TopicTypes$',
  }

  export enum SearchCommon {
    TopicIdVirtual = '$$TopicId$$',
  }

  export enum KeyWordList {
    Description = 'Description',
  }

  export enum MonitoringVisitLog {
    VisitTypeId = '$VisitTypeId$',
    InvestigativeSiteId = '$InvestigativeSiteId$',
    VisitDate = '$VisitDate$',
    VisitCompletedDate = '$VisitCompletedDate$',
    VisitStatusId = '$VisitStatusId$',
    VisitType = '$$VisitType$$',
    TopicName = 'TopicName',
  }

  export enum StudyStatus {
    StatusTypeId = 'StatusTypeId',
  }

  export enum Contract {
    Document = '$Document$',
    Facility = '$Facility$',
    StatusId = '$StatusId$',
    SentDate = '$SentDate$',
    FinalizedDate = '$FinalizedDate$',
    ExpirationDate = '$ExpirationDate$',
    Comments = '$Comments$',
    StatusName = '$$StatusName$$',
    AttachmentId = '$$AttachmentId$$',
    AttachmentName = '$$AttachmentName$$',
    CreatedBy = '$$CreatedBy$$',
  }

  export enum Budget {
    Document = '$Document$',
    Facility = '$Facility$',
    StatusId = '$StatusId$',
    SentDate = '$SentDate$',
    FinalizedDate = '$FinalizedDate$',
    ExpirationDate = '$ExpirationDate$',
    Comments = '$Comments$',
    StatusName = '$$StatusName$$',
    AttachmentId = '$$AttachmentId$$',
    AttachmentName = '$$AttachmentName$$',
    CreatedBy = '$$CreatedBy$$',
  }

  export namespace CustomExportMetadata {
    //specific custom fields mostly used instead of former hardcoded field names
    // if not custom - should be replaced in corresponding export code by regular field names from FieldNames namespace
    export enum Security {
      //common
      FullAccess = '$$FullAccess$$',
      PrevFullAccess = '$$PrevFullAccess$$',
      ViewOnly = '$$ViewOnly$$',
      PrevViewOnly = '$$PrevViewOnly$$',
      NoWatermark = '$$NoWatermark$$',
      PrevNoWatermark = '$$PrevNoWatermark$$',
      Redacted = '$$Redacted$$',
      PrevRedacted = '$$PrevRedacted$$',
      NoAccess = '$$NoAccess$$',
      PrevNoAccess = '$$PrevNoAccess$$',
      SecurityLastUpdatedBy = '$$SecurityLastUpdatedBy$$',
      SecurityLastUpdatedDate = '$$SecurityLastUpdatedDate$$',

      //folder
      TopicId = '$$TopicId$$',
      Index = '$$Index$$',

      //all(extra)
      Print = '$$Print$$',
      Save = '$$Save$$',
      LastUpdatedDate = '$$LastUpdatedDate$$',
    }

    export enum CRA {
      VisitStatus = '$$VisitStatus$$',
      VisitDate = '$$VisitDate$$',
      VisitStatusId = '$$VisitStatusId$$',
    }

    export enum Contact {
      InvestigativeSiteName = 'InvestigativeSiteName',
      SiteNumber = 'SiteNumber',
      ContactStatus = 'ContactStatus',
      ContactTypeName = 'ContactTypeName',
      UserName = 'UserName',
      FirstName = 'FirstName',
      LastName = 'LastName',
      Address = 'Address',
      City = 'City',
      State = 'State',
      Country = 'Country',
      ZipCode = 'ZipCode',
      MobileNo = 'MobileNo',
      PhoneNo = 'PhoneNo',
      EmailAddress = 'EmailAddress',
      Prefix = 'Prefix',
      Suffix = 'Suffix',
    }
  }

  export namespace UserManagement {
    export enum Team {
      RootGroupId = '$RootGroupId$',
      MemberCount = '$$MemberCount$$',
      GroupMemberCount = '$$GroupMemberCount$$',
      UserMemberCount = '$$UserMemberCount$$',
      DocTypeCount = '$$DocTypeCount$$',
      TopicName = '$$TopicName$$',
      Name = 'Name',
      Description = '$Description$',
      Purpose = '$TeamTypeId$',
      RecordTypeCount = '$$RecordTypeCount$$',
      CreatedDate = '$$CreatedDate$$',
      CreatedBy = '$$AddedById$$',
    }
  }

  export namespace QMS {
    export enum Incident {
      AwarenessDate = '$AwarenessDate$',
      Comments = '$Comments$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      DueDate = '$DueDate$',
      Description = '$Description$',
      ID = '$ID$',
      Impact = '$ImpactId$',
      ImpactName = '$$ImpactName$$',
      IncidentDate = '$IncidentDate$',
      isFavorite = '$$IsFavorite$$',
      Organization = '$OrganizationId$',
      OrganizationName = '$$OrganizationName$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      Products = '$ProductIds$',
      ProductNames = '$$ProductNames$$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      ReportedOn = '$ReportedOn$',
      Reporter = '$ReporterId$',
      ReporterName = '$$ReporterName$$',
      ResolvedBy = '$ResolvedById$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$ResolvedDate$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      Title = '$Title$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      WorkflowStageStatus = '$$WorkflowStageStatus$$',
    }

    export enum Capa {
      Title = '$Title$',
      ID = '$ID$',
      isFavorite = '$$IsFavorite$$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      Organization = '$OrganizationId$',
      OrganizationName = '$$OrganizationName$$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      DueDate = '$DueDate$',
      Impact = '$ImpactId$',
      ImpactName = '$$ImpactName$$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      Products = '$ProductIds$',
      ProductNames = '$$ProductNames$$',
      Reporter = '$ReporterId$',
      ReporterName = '$$ReporterName$$',
      ReportedOn = '$ReportedOn$',
      IdentifiedOn = '$IdentifiedOn$',
      RootCause = '$RootCause$',
      Description = '$Description$',
      Comments = '$Comments$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      ResolvedBy = '$ResolvedById$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$ResolvedDate$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      ImmediateAction = '$ImmediateAction$',
      CorrectiveAction = '$CorrectiveAction$',
      PreventativeAction = '$PreventativeAction$',
      CloseRequirements = '$CloseRequirements$',
      StageStatus = '$$StageStatusId$$',
      StageStatusName = '$$StageStatusName$$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      WorkflowStageStatus = '$$WorkflowStageStatus$$',
    }

    export enum ActionItem {
      Title = '$Title$',
      ID = '$ID$',
      isFavorite = '$$IsFavorite$$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      Organization = '$OrganizationId$',
      OrganizationName = '$$OrganizationName$$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      DueDate = '$DueDate$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      Products = '$ProductIds$',
      ProductNames = '$$ProductNames$$',
      Description = '$Description$',
      Comments = '$Comments$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      ResolvedBy = '$ResolvedById$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$ResolvedDate$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      StatusTypeId = '$$StatusTypeId$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      EstimatedTime = '$EstimatedTime$',
      ActionsTaken = '$ActionsTaken$',
      VerifiedById = '$VerifiedById$',
      VerifiedByName = '$$VerifiedByName$$',
      VerifiedOn = '$VerifiedOn$',
      EffectivenessCheck = '$$EffectivenessCheck$$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      WorkflowStageStatus = '$$WorkflowStageStatus$$',
    }

    export enum RecordStatus {
      StatusColorId = '$StatusColorId$',
      StatusTypeId = '$StatusTypeId$',
    }

    export enum Evidence {
      Title = '$Title$',
      Comments = '$Comments$',
      AddedById = '$$AddedById$$',
      AddedBy = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      LastUpdatedDate = '$$LastUpdatedDate$$',
      LastUpdatedById = '$$LastUpdatedById$$',
      LastUpdatedBy = '$$LastUpdatedBy$$',
      FileType = '$$FileType$$',
      FileName = '$$FileName$$',
      FileSize = '$$FileSize$$',
      AttachmentType = '$AttachmentType$',
      DocumentId = '$DocumentId$',
      DocumentName = '$$DocumentName$$',
      Url = '$Url$',
      Type = '$Type$', // no match on backend, probably we can remove it
      CreatedForRecordId = '$CreatedForRecordId$',
      CreatedForRecordStageId = '$CreatedForRecordStageId$',
    }

    export enum Product {
      Description = '$Description$',
    }

    export enum Impact {
      SeverityId = '$SeverityId$',
      ColorId = '$ColorId$',
      IconId = '$IconId$',
      Disabled = '$Disabled$',
    }

    export enum CommonSubTopic {
      SectionStatus = '$$SectionStatusId$$',
      SectionStatusName = '$$SectionStatusName$$',
      SectionStatusDate = '$$SectionStatusDate$$',
      ReviewerId = '$$ReviewerId$$',
      ReviewerName = '$$ReviewerName$$',
      WorkflowStageId = '$WorkflowStageId$',
      AccessRight = '$$AccessRight$$',
      Owner = '$OwnerId$',
      CompletedDate = '$CompletedDate$',
      // @todo check field
      StageDueDate = '$StageDueDate$',
    }

    export enum CommonMainTopic {
      ID = '$ID$',
      Status = '$StatusId$',
      CurrentWorkflow = '$$CurrentWorkflow$$',
      CurrentWorkflowReviewer = '$$CurrentWorkflowReviewer$$',
      CurrentWorkflowStage = '$$CurrentWorkflowStage$$',
      CurrentWorkflowStageId = '$$CurrentWorkflowStageId$$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      CurrentWorkflowStageStatusTopicId = '$$CurrentWorkflowStageStatusTopicId$$',
      StatusTypeId = '$$StatusTypeId$$',
      Title = '$Title$',
      Type = '$TypeId$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      LockedByName = '$$LockedByName$$',
      IsAssignedApproverAuthority = '$$IsAssignedApproverAuthority$$',
      DueDate = '$DueDate$',
      CreatedDate = '$$CreatedDate$$',
      CurrentWorkflowStageDueDate = '$$CurrentWorkflowStageDueDate$$',
      OpenEffectivenessCheckIds = '$$OpenEffectivenessCheckIds$$',
      EnableAdHocAssignment = '$$EnableAdHocAssignment$$',
      HasApplicableWorkflows = '$$HasApplicableWorkflows$$',
      Owner = '$OwnerId$',
      OpenRelatedRecordIdList = '$$OpenRelatedRecordIdList$$',
      HasOpenQueries = '$$HasOpenQueries$$',
      AccessRight = '$$AccessRight$$',
      CanAddRelatedRecord = '$$CanAddRelatedRecord$$',
      CanAddEvidence = '$$CanAddEvidence$$',
      CreatedBy = '$$AddedById$$',
      ResolvedBy = '$ResolvedById$',
      Products = '$ProductIds$',
      Organization = '$OrganizationId$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      WorkflowStageStatus = '$$WorkflowStageStatus$$',
      RelationType = '$$RelationType$$',
      StatusChangedBy = '$StatusChangedById$',
      LastUpdatedBy = '$LastUpdatedById$',
      ClosedBy = '$ClosedById$',
      CancelledBy = '$CancelledById$',
      TypeName = '$$TypeName$$',
      IsFavorite = '$$IsFavorite$$',
      OwnerName = '$$OwnerName$$',
      StatusName = '$$StatusName$$',
      CreatedByName = '$$AddedBy$$',
      LastUpdatedDate = '$$LastUpdatedDate$$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$$ResolvedDate$$',
      ResolvedComments = '$$ResolvedComments$$',
      StatusDate = '$StatusDate$',
      StatusComments = '$StatusComments$',
      StatusChangedByName = '$$StatusChangedByName$$',
      ClosedByName = '$$ClosedByName$$',
      ClosedDate = '$$ClosedDate$$',
      CancelledByName = '$$CancelledByName$$',
      CancelledDate = '$$CancelledDate$$',
      RelationCreatedBy = '$$RelationCreatedBy$$',

      SecurityLastUpdatedDate = '$$SecurityLastUpdatedDate$$',
      SecurityLastUpdatedBy = '$$SecurityLastUpdatedBy$$',
      AuditTrailCreatedBy = '$$AuditTrail_CreatedBy$$',
      AuditTrailActivityDate = '$$AuditTrail_ActivityDate$$',
      AuditTrailActivityType = '$$AuditTrail_ActivityType$$',
      AuditTrailActivityRelatedData = '$$AuditTrail_ActivityRelatedData$$',

      PlannedDate = '$PlannedDate$',
      PlannedDescription = '$PlannedDescription$',
      PlannedReminder = '$PlannedReminder$',
    }

    export enum Investigation {
      CauseCategory = '$CauseCategory$',
      CauseType = '$CauseType$',
      CauseDetail = '$CauseDetail$',
      InvestigationType = '$InvestigationType$',
      Summary = '$Summary$',
      RootCause = '$RootCause$',
      RootCauseAnalysis = '$RootCauseAnalysis$',
      WorkflowStage = '$WorkflowStageId$',
    }

    export enum Assessment {
      AssignedTo = '$AssignedTo$',
      CompletedDate = '$CompletedDate$',
      ImpactAnalysis = '$ImpactAnalysis$',
      RiskAnalysis = '$RiskAnalysis$',
      WorkflowStage = '$WorkflowStageId$',
    }
    export enum QualityApproval {
      QAFeedback = '$QAFeedback$',
      ApprovedBy = '$ApprovedById$',
      ApprovalDate = '$ApprovalDate$',
      AssignedTo = '$AssignedTo$',
      WorkflowStageId = '$WorkflowStageId$',
    }

    export enum Audit {
      Title = '$Title$',
      isFavorite = '$$IsFavorite$$',
      ID = '$ID$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      DueDate = '$DueDate$',
      Organization = '$OrganizationId$',
      OrganizationName = '$$OrganizationName$$',
      OrganizationNumber = '$$OrganizationNumber$$',
      OrganizationType = '$$OrganizationType$$',
      OrganizationSubType = '$$OrganizationSubType$$',
      OrganizationCountry = '$$OrganizationCountry$$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      InvestigativeSiteAutoName = '$$InvestigativeSiteAutoName$$',
      InvestigativeSiteNumber = '$$InvestigativeSiteNumber$$',
      InvestigativeSitePI = '$$InvestigativeSitePI$$',
      InvestigativeSiteCountry = '$$InvestigativeSiteCountry$$',
      Impact = '$ImpactId$',
      ImpactName = '$$ImpactName$$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      ResolvedBy = '$$ResolvedById$$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$$ResolvedDate$$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      AuditType = '$AuditType$',
      AuditPurpose = '$AuditPurpose$',
      AuditScope = '$AuditScope$',
      Auditee = '$Auditee$',
    }

    export enum Finding {
      Title = '$Title$',
      ID = '$ID$',
      isFavorite = '$$IsFavorite$$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      DueDate = '$DueDate$',
      Organization = '$OrganizationId$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      Impact = '$ImpactId$',
      ImpactName = '$$ImpactName$$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      ResolvedBy = '$$ResolvedById$$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$$ResolvedDate$$',
      Description = '$Description$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      Auditee = '$Auditee$',
      OrganizationName = '$$OrganizationName$$',
      OrganizationNumber = '$$OrganizationNumber$$',
      OrganizationType = '$$OrganizationType$$',
      OrganizationSubType = '$$OrganizationSubType$$',
      OrganizationCountry = '$$OrganizationCountry$$',
      InvestigativeSiteAutoName = '$$InvestigativeSiteAutoName$$',
      InvestigativeSiteNumber = '$$InvestigativeSiteNumber$$',
      InvestigativeSitePI = '$$InvestigativeSitePI$$',
      InvestigativeSiteCountry = '$$InvestigativeSiteCountry$$',
    }

    export enum SupplierQualification {
      Title = '$Title$',
      ID = '$ID$',
      isFavorite = '$$IsFavorite$$',
      Type = '$TypeId$',
      TypeName = '$$TypeName$$',
      Status = '$StatusId$',
      StatusName = '$$StatusName$$',
      Owner = '$OwnerId$',
      OwnerName = '$$OwnerName$$',
      Team = '$TeamId$',
      TeamName = '$$TeamName$$',
      DueDate = '$DueDate$',
      Organization = '$OrganizationId$',
      OrganizationName = '$$OrganizationName$$',
      OrganizationNumber = '$$OrganizationNumber$$',
      OrganizationType = '$$OrganizationType$$',
      OrganizationSubType = '$$OrganizationSubType$$',
      OrganizationCountry = '$$OrganizationCountry$$',
      InvestigativeSiteId = '$InvestigativeSiteId$',
      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      InvestigativeSiteAutoName = '$$InvestigativeSiteAutoName$$',
      InvestigativeSiteNumber = '$$InvestigativeSiteNumber$$',
      InvestigativeSitePI = '$$InvestigativeSitePI$$',
      InvestigativeSiteCountry = '$$InvestigativeSiteCountry$$',
      Impact = '$ImpactId$',
      ImpactName = '$$ImpactName$$',
      CreatedBy = '$$AddedById$$',
      CreatedByName = '$$AddedBy$$',
      CreatedDate = '$$CreatedDate$$',
      ResolvedBy = '$$ResolvedById$$',
      ResolvedByName = '$$ResolvedByName$$',
      ResolvedDate = '$$ResolvedDate$$',
      CurrentWorkflowStageStatus = '$$CurrentWorkflowStageStatus$$',
      QualificationRationale = '$QualificationRationale$',
      GxpRelevance = '$GxpRelevance$',
      GxpArea = '$GxpArea$',
      CriticalSupplier = '$CriticalSupplier$',
    }

    export enum RecordType {
      TeamId = '$$TeamId$$',
      TeamName = '$$TeamName$$',
      DueDate = '$DueDate$',
      Hierarchy = '$$Hierarchy$$',
      EffectivenessCheck = '$EffectivenessCheck$',
      EnableAdHocAssignment = '$EnableAdHocAssignment$',
      CategoryName = '$$CategoryName$$',
    }
  }

  export enum UserSession {
    EmailAddress = 'EmailAddress',
    FirstName = 'FirstName',
    LastName = 'LastName',
    OrganizationName = 'OrganizationName',
    MobileNo = 'MobileNo',
    PhoneNo = 'PhoneNo',
    IPAddress = 'IPAddress',
    CreatedDate = 'CreatedDate',
    ExpirationDate = 'ExpirationDate',
    UpdatedDate = 'UpdatedDate',
    NodeHostName = 'NodeHostName',
    NodeIPAddress = 'NodeIPAddress',
    UserAgent = 'UserAgent',
    SessionId = 'SessionId',
    UserId = 'UserId',
  }

  export enum ExportRequestsLog {
    StatusId = 'StatusId',
    CreatedDate = 'CreatedDate',
    UserId = 'UserId',
    ServerTaskQueueId = 'ServerTaskQueueId',
    ServerTaskQueueTaskTypeId = 'ServerTaskQueueTaskTypeId',
    UploadExportType = 'UploadExportType',
    ExpirationDate = 'ExpirationDate',
    DocumentArchiveSize = 'DocumentArchiveSize',
    FilesCount = 'FilesCount',
    DownloadLink = 'DownloadLink',
    Password = 'Password',
    RoomName = 'RoomName',
    FullName = 'FullName',
    EmailAddress = 'EmailAddress',
    ProgressTotal = 'ProgressTotal',
    RoomId = 'RoomId',
  }

  export enum AutomateFlag {
    Title = 'Title',
    Name = 'Name',
    AiFlagId = 'AiFlagId',
    AiFlagSeverityId = 'AiFlagSeverityId',
    AiFlagTypeId = 'AiFlagTypeId',
    FlagAttributes = 'FlagAttributes',
    RoomTypeFilters = 'RoomTypeFilters',
    ClientFilters = 'ClientFilters',
    WorkflowIssueName = 'WorkflowIssueName',
    IsEnabled = 'IsEnabled',
    Clients = 'Clients',
    Enabled = 'Enabled',
    RoomTypes = 'Room Types',
    Severity = 'Severity',
  }

  export namespace Query {
    export enum Common {
      QueryId = '$$QueryId$$',
      QueryDate = '$$QueryDate$$',
      QueryCreatedBy = '$$QueryCreatedBy$$',
      QueryCreatedByRole = '$$QueryCreatedByRole$$',
      QueryType = '$$QueryType$$',
      QueryStatus = '$$QueryStatus$$',
      QueryRecipients = '$$QueryRecipients$$',
      QueryRecipientsRoles = '$$QueryRecipientsRoles$$',
      QueryRecipientsEmails = '$$QueryRecipientsEmails$$',
      QuerySubject = '$$QuerySubject$$',
      QueryRequest = '$$QueryRequest$$',
      QueryResponse = '$$QueryResponse$$',
      QueryResponseDate = '$$QueryResponseDate$$',
      QueryIssues = '$$QueryIssues$$',
      TopicTypeId = '$$TopicTypeId$$',
      NotRequiredForCompleteness = '$$NotRequiredForCompleteness$$',
      CompletenessStatusId = '$$CompletenessStatusId$$',
      IsFavorite = '$$IsFavorite$$',
      TopicId = '$$TopicId$$',
    }

    export enum Document {
      DocumentId = '$$DocumentId$$',
      DocumentTitle = '$$DocumentTitle$$',
      DocumentName = '$$DocumentName$$',
      DocumentType = '$$DocumentType$$',
      DocumentFileName = '$$DocumentFileName$$',
      DocumentCategory = '$$DocumentCategory$$',
      DocumentIndex = '$$DocumentIndex$$',
    }

    export enum Record {
      RecordTitle = '$$RecordTitle$$',
      RecordId = '$$RecordId$$',
      RecordType = '$$RecordType$$',
      RecordTypeId = '$$RecordTypeId$$',
      RecordStatus = '$$RecordStatus$$',
      RecordStatusId = '$$RecordStatusId$$',
      RecordOwnerId = '$$RecordOwnerId$$',
      RecordOwner = '$$RecordOwner$$',
      RecordFormId = '$$RecordFormId$$',
      RecordForm = '$$RecordForm$$',
      RecordTeamId = '$$RecordTeamId$$',
      RecordTeam = '$$RecordTeam$$',
    }
  }

  export namespace CountryWorkflow {
    export enum Workflow {
      Description = '$Description$',
      StartDate = '$StartDate$',
    }

    export enum WorkflowMilestone {
      Description = '$Description$',
      PlannedDateCondition = 'PLannedDateCondition',
      CategoryId = '$CategoryId$',
      LevelId = '$LevelId$',
      MilestoneTypeId = '$MilestoneTypeId$',
      SourceTemplateId = '$SourceTemplateId$',
    }

    export enum CountryMilestoneTemplate {
      SourceTemplateId = '$SourceTemplateId$',
      isFavorite = '$$IsFavorite$$',
      MilestoneTypeId = '$MilestoneTypeId$',
      LevelId = '$LevelId$',
      LevelName = '$$Level$$',
      CategoryId = '$CategoryId$',
      CategoryName = '$$Category$$',
      Description = '$Description$',
      StatusId = '$StatusId$',
      StatusName = '$$Status$$',
      CountryIso2 = '$$CountryIso2$$',
      IsOverdue = '$$IsOverdue$$',
      StatusComments = '$StatusComments$',

      ActualDate = '$ActualDate$',
      LastUpdatedBy = '$$LastUpdatedBy$$',
      LastUpdatedDate = '$$LastUpdatedDate$$',
      CreatedDate = '$$CreatedDate$$',
      SecurityLastUpdatedDate = '$$SecurityLastUpdatedDate$$',
      SecurityLastUpdatedBy = '$$SecurityLastUpdatedBy$$',
      AuditTrailCreatedBy = '$$AuditTrail_CreatedBy$$',
      AuditTrailActivityDate = '$$AuditTrail_ActivityDate$$',
      AuditTrailActivityType = '$$AuditTrail_ActivityType$$',
      AuditTrailActivityRelatedData = '$$AuditTrail_ActivityRelatedData$$',

      PlannedDateDependsOn = '$PlannedDateDependsOn$',
      PlannedDateDelay = '$PlannedDateDelay$',
      Countries = '$Countries$',
      PlannedDate = '$PlannedDate$',

      CountryName = '$$CountryName$$',
      CountryTopicId = '$$CountryTopicId$$',

      InvestigativeSiteName = '$$InvestigativeSiteName$$',
      InvestigativeSiteTopicId = '$$InvestigativeSiteTopicId$$',
      InvestigativeSiteDomainTopicId = '$$InvestigativeSiteDomainTopicId$$',

      //
      ParentId = 'ParentId',

      // only UI fields
      PlannedDateCondition = 'PLannedDateCondition',
      RoomLevelManualPlannedDate = '$RoomLevelManualPlannedDate$',
      TopicName = 'TopicName',
    }
    export enum CountryWorkflowTemplate {
      LastUpdatedDate = '$$LastUpdatedDate$$',
      LastUpdatedBy = '$$LastUpdatedBy$$',
      CreatedDate = '$$CreatedDate$$',
      SecurityLastUpdatedDate = '$$SecurityLastUpdatedDate$$',
      SecurityLastUpdatedBy = '$$SecurityLastUpdatedBy$$',
      AuditTrailCreatedBy = '$$AuditTrail_CreatedBy$$',
      AuditTrailActivityDate = '$$AuditTrail_ActivityDate$$',
      AuditTrailActivityType = '$$AuditTrail_ActivityType$$',
      AuditTrailActivityRelatedData = '$$AuditTrail_ActivityRelatedData$$',
      Description = '$Description$',
      StatusId = '$StatusId$',
      Countries = '$Countries$',
      isFavorite = '$$IsFavorite$$',
      StatusName = '$$Status$$',
      StatusComments = '$StatusComments$',

      // only UI fields
      TopicName = 'TopicName',
      MilestonesList = 'MilestonesList',
      UpdatedByFull = 'UpdatedByFull',
    }
  }
}
